module.exports = __webpack_public_path__ + "static/media/05.f255b44b.mp3";